module.exports = __webpack_public_path__ + "static/media/3.Self Priming motor (0.5Hp - 1.0Hp).fb0c3786.png";